export default __webpack_public_path__ + "static/media/keyvisual-bodensee.eb47404a.jpg";